<template>
  <div class="container">
    <!--UPLOAD-->
    <form enctype="multipart/form-data" novalidate>
      <div v-if="experienceUpload">
        <h5 v-if="imagePath">{{ $t('changeEimage') }}</h5>
        <h3 v-else>{{ $t('addEimage') }}</h3>
      </div>
      <div v-else>
        <h5 v-if="imagePath">{{ $t('changePimage') }}</h5>
        <h3 v-else>{{ $t('addPimage') }}</h3>
      </div>
      <div class="dropbox">
        <input
          type="file"
          :name="uploadFieldName"
          :disabled="isSaving"
          @change="filesChange($event.target.name, $event.target.files)"
          accept="image/*"
          class="input-file"
        />
        <p v-if="!imageUrl">
          {{ $t('uploadInstuctions1') }}<br />
          {{ $t('uploadInstuctions2') }}
        </p>
        <p v-if="isSaving">
          {{ $t('uploading') }}
        </p>
        <img
          v-if="imageUrl || isSuccess"
          :src="`${imageUrl}`"
          class="img-responsive img-thumbnail"
          alt="No image found"
        />
      </div>
    </form>
    <!--SUCCESS-->
    <!-- <div v-if="isSuccess">
            <h2>Image uploaded successfully.</h2>
            <p>
            <a href="javascript:void(0)" @click="reset()">Upload again</a>
            </p>
            <ul class="list-unstyled">
            <li :key = "item" v-for="item in uploadedFiles">
                <img 
                :src="item.url" 
                class="img-responsive img-thumbnail" 
                :alt="item.originalName">
            </li>
            </ul>
        </div> -->
    <!--FAILED-->
    <div v-if="isFailed">
      <h2>Uploaded failed.</h2>
      <p>
        <a href="javascript:void(0)" @click="reset()">Try again</a>
      </p>
      <!-- <pre>{{ uploadError }}</pre> -->
    </div>
  </div>
</template>

<script>
import { upload } from '@/services/prodImgUpload.service.js'
import constants from '@/utils/Constants.js'

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3

export default {
  props: {
    unitId: {
      type: Number,
      default: () => {
        return ''
      },
    },
    productId: {
      type: Number,
      default: () => {
        return ''
      },
    },
    imageUrl: {
      type: String,
      default: null,
    },
    experienceUpload: {
      type: Boolean,
      default: false,
    },
  },
  name: 'app',
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'file',
      baseUrl: process.env.VUE_APP_API_URL,
    }
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED
    },
  },
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING
      const params = this.experienceUpload
        ? {
            type: constants.UNIT_EXP,
            unit_id: this.unitId,
            experience_id: this.productId,
          }
        : {
            type: constants.UNIT,
            unit_id: this.unitId,
            product_id: this.productId,
          }

      upload(formData, params)
        .then((x) => {
          this.uploadedFiles = [].concat(x)
          this.imageUrl = x.cloudUrl
          this.currentStatus = STATUS_SUCCESS
        })
        .catch((err) => {
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
        })
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData()

      if (!fileList.length) return

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(fieldName, fileList[x], fileList[x].name)
      })

      // save it
      this.save(formData)
    },
  },
  mounted() {
    this.reset()
  },
}
</script>

<style lang="scss" scoped>
.dropbox {
	outline: 2px dashed grey; /* the dash box */
	outline-offset: -10px;
	background: rgba(44, 62, 80, 0.2);
	color: dimgray;
	padding: 10px 10px;
	position: relative;
	max-width: 300px;
	margin: auto;
	width: auto;
	height: auto;
	cursor: pointer;
}

.container {
  display: inline-block;
  width: 60%;
  margin: 0;
  padding: 0;
}

form {
  padding: 0;
  width: auto;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  left: 0;
  height: 100%;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: rgba(
    185,
    123,
    66,
    0.4
  ); /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

@media screen and (max-width: 500px) {
  .container {
    width: 100%;
  }

  .dropbox {
    width: 100%;
  }

  form {
    width: 100%;
  }
}
</style>